/* global axios */
import ApiClient from './ApiClient';

class GoogleContactsAuthClient extends ApiClient {
  constructor() {
    super('google_contacts', { accountScoped: true });
  }

  generateAuthorization() {
    return axios.post(`${this.url}/authorization`);
  }
}

export default new GoogleContactsAuthClient();
